module.exports = __webpack_public_path__ + "public/images/stands-bookmarks-off.75a99596d76afdcecc8de24578320fba.svg";